import { Fragment, useEffect, useState } from "react";
import "./PhoneForm.scss";
import { useStep } from "usehooks-ts";
import PhoneStepOne from "./_components/PhoneStepOne";
import PhoneStepTwo from "./_components/PhoneStepTwo";
import { CustomerData } from "../../../../../models/authUserModel";
import { TabsComponentProps } from "../TabsComponent";

const PhoneNumberForm = ({ customerInfo }: TabsComponentProps) => {
    const [currentStep, helpers] = useStep(2) 
  return (
    <Fragment>
        {(() => {
        switch (currentStep) {
          case 1:
            return <PhoneStepOne helpers={helpers} customerInfo={customerInfo} />;
          case 2:
            return <PhoneStepTwo helpers={helpers}/>;
          default:
            return null;
        }
      })()}
    </Fragment>
  );
};
export default PhoneNumberForm;
